'use client';
import { Button, Divider } from '@heroui/react';
import InView from '@/components/ui/in-view';
import { LEARN_MORE_HEADER_SECTION_ID, LEARN_MORE_PRE_REGISTER_SECTION_ID } from '../../shared/constants/section-ids';

export function LearnMoreHeader() {
	return (
		<div id={LEARN_MORE_HEADER_SECTION_ID} className="size-full z-10 scroll-mt-40 p-8 flex items-center justify-center select-none">
			<InView
				variants={{
					hidden: { opacity: 0, y: 0, filter: 'blur(4px)' },
					visible: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { delay: 0.1 } },
				}}
				viewOptions={{ margin: '0px 0px -0px 0px', once: true }}
				transition={{ duration: 0.3, ease: 'easeInOut' }}
			>
				<div className="flex flex-col items-center justify-center  gap-4">
					<h1 className="font-playflair text-center md:text-7xl text-5xl font-bold leading-snug ">Clube Pormade</h1>
					<Divider className="max-w-2/3 bg-secondary" />
					<p className=" text-center md:max-w-2/3 md:text-2xl text-xl leading-relaxed ">
						Uma comunidade exclusiva que transforma o design e a arquitetura
					</p>
					<Button as="a" href={`#${LEARN_MORE_PRE_REGISTER_SECTION_ID}`} variant="solid" size="lg" color="secondary">
						Quero fazer parte
					</Button>
				</div>
			</InView>
		</div>
	);
}
